import posthog from 'posthog-js';

/**
 * Report an error to PostHog and the console without changing user-facing
 * behavior. Use in catch blocks that would otherwise discard the error.
 */
export function reportError(
  error: unknown,
  context?: Record<string, unknown>
): void {
  console.error(error, context);
  if (!posthog.__loaded) return;
  posthog.captureException(
    error instanceof Error ? error : new Error(String(error)),
    context
  );
}

export function track(
  event: string,
  properties?: Record<string, unknown>
): void {
  if (!posthog.__loaded) return;
  posthog.capture(event, properties);
}
